import React from 'react';
import { getEducationLabel } from './MaritalHistory';

const ReviewStep1 = ({ formData, updateFormData, nextStep, prevStep, goToStep }) => {
  const partyA = formData.partyA || {};
  const maritalHistory = partyA.maritalHistory || {};

  return (
    <div>
      <h1 className="form-section-title">Review - {partyA.role || 'Party A'} Information</h1>

      {/* Basic Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Party Type & Sex</h3>
          <button onClick={() => goToStep(6)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Party Type:</div>
          <div className="review-value">{partyA.role || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Sex:</div>
          <div className="review-value">{partyA.sex || 'Not provided'}</div>
        </div>
      </div>

      {/* Name Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Name Information</h3>
          <button onClick={() => goToStep(6)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">First Name:</div>
          <div className="review-value">{partyA.firstName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Middle Name:</div>
          <div className="review-value">{partyA.middleName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Last Name:</div>
          <div className="review-value">{partyA.lastName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Suffix:</div>
          <div className="review-value">{partyA.suffix || 'None'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Last Name Before Marriage:</div>
          <div className="review-value">{partyA.lastNameBeforeMarriage || 'Not provided'}</div>
        </div>
      </div>

      {/* Residence Address */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Residence Address</h3>
          <button onClick={() => goToStep(6)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Address:</div>
          <div className="review-value">{partyA.residenceAddress || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">City:</div>
          <div className="review-value">{partyA.city || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Parish/County:</div>
          <div className="review-value">{partyA.parish || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">State:</div>
          <div className="review-value">{partyA.state || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">ZIP:</div>
          <div className="review-value">{partyA.zip || 'Not provided'}</div>
        </div>
      </div>

      {/* Birth Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Birth Information</h3>
          <button onClick={() => goToStep(6)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Race:</div>
          <div className="review-value">{partyA.race || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Date of Birth:</div>
          <div className="review-value">{partyA.dateOfBirth || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - City:</div>
          <div className="review-value">{partyA.birthCity || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - State:</div>
          <div className="review-value">{partyA.birthState || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - Country:</div>
          <div className="review-value">{partyA.birthCountry || 'Not provided'}</div>
        </div>
      </div>

      {/* Mother/Parent Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Mother/Parent Information</h3>
          <button onClick={() => goToStep(6)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Mother/Parent's Name:</div>
          <div className="review-value">{partyA.motherName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - City:</div>
          <div className="review-value">{partyA.motherBirthCity || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - State:</div>
          <div className="review-value">{partyA.motherBirthState || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - Country:</div>
          <div className="review-value">{partyA.motherBirthCountry || 'Not provided'}</div>
        </div>
      </div>

      {/* Father/Parent Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Father/Parent Information</h3>
          <button onClick={() => goToStep(6)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Father/Parent's Name:</div>
          <div className="review-value">{partyA.fatherName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - City:</div>
          <div className="review-value">{partyA.fatherBirthCity || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - State:</div>
          <div className="review-value">{partyA.fatherBirthState || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - Country:</div>
          <div className="review-value">{partyA.fatherBirthCountry || 'Not provided'}</div>
        </div>
      </div>

      {/* Contact Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Contact Information</h3>
          <button onClick={() => goToStep(6)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Social Security Number:</div>
          <div className="review-value">
            {partyA.ssn ? `*****${partyA.ssn.slice(5)}` : 'Not provided'}
          </div>
        </div>
        <div className="review-item">
          <div className="review-label">SSN Confidential:</div>
          <div className="review-value">{partyA.ssnConfidential ? 'Yes' : 'No'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Phone Number:</div>
          <div className="review-value">{partyA.phoneNumber || partyA.phone || 'Not provided'}</div>
        </div>
      </div>

      {/* Marital History */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Marital History</h3>
          <button onClick={() => goToStep(11)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Number of Previous Marriages:</div>
          <div className="review-value">{maritalHistory.previousMarriages || 'Not provided'}</div>
        </div>
        {maritalHistory.previousMarriages && parseInt(maritalHistory.previousMarriages) > 0 && (
          <>
            <div className="review-item">
              <div className="review-label">Date Last Marriage Ended:</div>
              <div className="review-value">{maritalHistory.lastMarriageEndDate || 'Not provided'}</div>
            </div>
            <div className="review-item">
              <div className="review-label">Reason Last Marriage Ended:</div>
              <div className="review-value">{maritalHistory.lastMarriageEndReason || 'Not provided'}</div>
            </div>
          </>
        )}
        <div className="review-item">
          <div className="review-label">Highest Education Completed:</div>
          <div className="review-value">{getEducationLabel(maritalHistory.education)}</div>
        </div>
      </div>

      {/* Relationship Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Relationship Information</h3>
          <button onClick={() => goToStep(8)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Consanguineous Relationship:</div>
          <div className="review-value">{formData.isConsanguineous === true ? 'Yes' : formData.isConsanguineous === false ? 'No' : 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Covenant Marriage:</div>
          <div className="review-value">{formData.isCovenantMarriage === true ? 'Yes' : formData.isCovenantMarriage === false ? 'No' : 'Not provided'}</div>
        </div>
      </div>

      <div className="step-navigation">
        <button onClick={prevStep} className="btn btn-secondary">Back</button>
        <button onClick={nextStep} className="btn btn-primary">Next</button>
      </div>
    </div>
  );
};

export default ReviewStep1;
